import { CARRIER_LIST, LOBS } from '@commpass/shared';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { BackIcon, PlusIcon } from '../components/Icons';
import { useToast } from '../components/Toast';
import { useAddCarrier, useAddLine, useCarriers, useLines } from '../data/reference';

export function Settings() {
  const navigate = useNavigate();
  const toast = useToast();
  const carriers = useCarriers();
  const lines = useLines();
  const addCarrier = useAddCarrier();
  const addLine = useAddLine();

  const [cName, setCName] = useState('');
  const [cLink, setCLink] = useState('');
  const [lName, setLName] = useState('');

  return (
    <div className="wrap">
      <div className="back-link" onClick={() => navigate('/')}>
        <BackIcon width={16} height={16} /> Back to submissions
      </div>
      <div className="page-head">
        <div>
          <div className="page-title">Settings</div>
          <div className="page-sub">Manage carriers and lines of business.</div>
        </div>
      </div>

      <div className="detail-grid">
        <div className="panel">
          <div className="panel-head">
            <h3>Carriers</h3>
          </div>
          <div className="panel-pad">
            <div className="sub-meta" style={{ marginBottom: 8 }}>Built-in</div>
            {[...CARRIER_LIST]
              .sort((a, b) => a.name.localeCompare(b.name))
              .map((c) => (
                <div key={c.name} style={{ padding: '6px 0', borderBottom: '1px solid var(--border)' }}>
                  {c.name}
                </div>
              ))}
            {(carriers.data ?? []).length > 0 && (
              <div className="sub-meta" style={{ margin: '12px 0 8px' }}>Added</div>
            )}
            {[...(carriers.data ?? [])]
              .sort((a, b) => a.name.localeCompare(b.name))
              .map((c) => (
                <div key={c.id} style={{ padding: '6px 0', borderBottom: '1px solid var(--border)' }}>
                  {c.name}
                </div>
              ))}
            <div style={{ display: 'grid', gap: 8, marginTop: 12 }}>
              <input className="finput" placeholder="Carrier name" value={cName} onChange={(e) => setCName(e.target.value)} />
              <input className="finput" placeholder="Portal link (optional)" value={cLink} onChange={(e) => setCLink(e.target.value)} />
              <button
                className="btn btn-ghost btn-sm"
                onClick={async () => {
                  if (!cName.trim()) return toast('Enter a name');
                  await addCarrier.mutateAsync({ name: cName.trim(), link: cLink.trim() });
                  setCName('');
                  setCLink('');
                  toast('Carrier added');
                }}
              >
                <PlusIcon width={15} height={15} /> Add carrier
              </button>
            </div>
          </div>
        </div>

        <div className="panel">
          <div className="panel-head">
            <h3>Lines of business</h3>
          </div>
          <div className="panel-pad">
            <div className="sub-meta" style={{ marginBottom: 8 }}>Built-in</div>
            {LOBS.map((l) => (
              <div key={l.id} style={{ padding: '6px 0', borderBottom: '1px solid var(--border)' }}>
                {l.name}
              </div>
            ))}
            {(lines.data ?? []).length > 0 && (
              <div className="sub-meta" style={{ margin: '12px 0 8px' }}>Added</div>
            )}
            {(lines.data ?? []).map((l) => (
              <div key={l.id} style={{ padding: '6px 0', borderBottom: '1px solid var(--border)' }}>
                {l.name}
              </div>
            ))}
            <div style={{ display: 'grid', gap: 8, marginTop: 12 }}>
              <input className="finput" placeholder="Line name" value={lName} onChange={(e) => setLName(e.target.value)} />
              <button
                className="btn btn-ghost btn-sm"
                onClick={async () => {
                  if (!lName.trim()) return toast('Enter a name');
                  await addLine.mutateAsync({ name: lName.trim() });
                  setLName('');
                  toast('Line added');
                }}
              >
                <PlusIcon width={15} height={15} /> Add line
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
